export const calculateFont = (fontSize = 16) => {
  const lineHeight = fontSize * 1.5 + 'px';
  const letterSpacing = (fontSize * 0.12)/100 + 'em';
  const wordSpacing = (fontSize * 0.16)/100 + 'em';
  return { fontSize: fontSize + 'px', lineHeight, letterSpacing, wordSpacing }
};

export const calculateFontWithMargin = (fontSize = 16) => {
  const marginBottom = fontSize * 2 + 'px';
  return { ...calculateFont(fontSize), marginBottom }
};